var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"task-source"},[_c(_vm.component,{ref:"data",tag:"component",attrs:{"id":_vm.dataId,"type":_vm.dataType,"query":_vm.query},on:{"source-switch":_vm.sourceSwitch,"data-theme-change":_vm.dataThemeChange}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }